import React from 'react';
export function BeforeAfterSection() {
  return <section className="w-full bg-black text-white py-16" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4" data-id="element-2">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-12" data-id="element-3">
          🔄 Antes vs Después
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-4">
          {/* Antes */}
          <div className="bg-gray-900 border border-red-900/50 p-8 rounded-2xl" data-id="element-5">
            <h3 className="text-2xl font-bold text-red-500 mb-6 flex items-center gap-2 border-b border-red-900/30 pb-4" data-id="element-6">
              <span data-id="element-7">❌</span> Antes del Mega Pack
            </h3>
            <ul className="space-y-4 text-lg text-gray-300" data-id="element-8">
              <li className="flex items-start gap-3" data-id="element-9">
                <span className="text-red-500 mt-1" data-id="element-10">✗</span>
                Niños aburridos en casa
              </li>
              <li className="flex items-start gap-3" data-id="element-11">
                <span className="text-red-500 mt-1" data-id="element-12">✗</span>
                Mucho tiempo frente a pantallas
              </li>
              <li className="flex items-start gap-3" data-id="element-13">
                <span className="text-red-500 mt-1" data-id="element-14">✗</span>
                Falta de ideas para actividades educativas
              </li>
              <li className="flex items-start gap-3" data-id="element-15">
                <span className="text-red-500 mt-1" data-id="element-16">✗</span>
                Dificultad para mantener su atención
              </li>
              <li className="flex items-start gap-3" data-id="element-17">
                <span className="text-red-500 mt-1" data-id="element-18">✗</span>
                Aprendizaje poco estimulante
              </li>
            </ul>
          </div>

          {/* Después */}
          <div className="bg-gray-900 border border-green-900/50 p-8 rounded-2xl shadow-[0_0_30px_rgba(34,197,94,0.15)] relative overflow-hidden" data-id="element-19">
            <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/10 rounded-full blur-3xl" data-id="element-20"></div>
            <h3 className="text-2xl font-bold text-green-500 mb-6 flex items-center gap-2 border-b border-green-900/30 pb-4" data-id="element-21">
              <span data-id="element-22">✅</span> Después del Mega Pack
            </h3>
            <ul className="space-y-4 text-lg text-gray-100" data-id="element-23">
              <li className="flex items-start gap-3" data-id="element-24">
                <span className="text-green-500 mt-1" data-id="element-25">✓</span>
                Niños entretenidos con actividades educativas
              </li>
              <li className="flex items-start gap-3" data-id="element-26">
                <span className="text-green-500 mt-1" data-id="element-27">✓</span>
                Menos tiempo frente a pantallas
              </li>
              <li className="flex items-start gap-3" data-id="element-28">
                <span className="text-green-500 mt-1" data-id="element-29">✓</span>
                Aprendizaje a través del juego
              </li>
              <li className="flex items-start gap-3" data-id="element-30">
                <span className="text-green-500 mt-1" data-id="element-31">✓</span>
                Mayor concentración
              </li>
              <li className="flex items-start gap-3" data-id="element-32">
                <span className="text-green-500 mt-1" data-id="element-33">✓</span>
                Estimulación del desarrollo infantil
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}